import Input from "immigram-ui-cmon/src/components/Input/Input";
import React from "react";
import { Control } from "react-hook-form";
import { Controller } from "react-hook-form";

import {
  ImmigramFormElementConfigBase,
  ImmigramFormElementType,
} from "./common";

export interface ImmigramFormElementConfigHidden
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Hidden;
  value?: string;
  name: string;
}

interface ImmigramFormHiddenProps {
  elementConfig: ImmigramFormElementConfigHidden;
  control: Control;
}

function ImmigramFormHidden({
  elementConfig,
  control,
}: ImmigramFormHiddenProps) {
  return (
    <Controller
      control={control}
      name={elementConfig.name}
      render={() => {
        return (
          <Input
            name={elementConfig.name}
            type="hidden"
            value={elementConfig.value}
          />
        );
      }}
    />
  );
}

export { ImmigramFormHidden };
